<div class="dialog-container specialty-form-dialog">
  <div class="form-header">
    <h5 mat-dialog-title>{{ isEditMode ? 'تعديل تخصص' : 'إضافة تخصص' }}</h5>
    <div class="close-icon" (click)="cancel()">
      <img src="assets/images/svg/closeModal.svg" alt="" />
    </div>
  </div>

  <form [formGroup]="specialtyFormGroup" (ngSubmit)="save()">
    <div mat-dialog-content>
      <div class="specialty-row two-col">
        <div class="form-field">
          <label class="form-label">
            الاسم (عربي)
            <span class="required">*</span>
          </label>
          <input
            type="text"
            class="form-control"
            formControlName="name_ar"
            placeholder="مثال: كهرباء"
            [class.is-invalid]="submitted && specialtyFormGroup.get('name_ar')?.invalid"
          />
          @if (submitted && specialtyFormGroup.get('name_ar')?.errors?.['required']) {
            <div class="invalid-feedback d-block">هذا الحقل مطلوب</div>
          }
          @if (specialtyFormGroup.get('name_ar')?.errors?.['backend']) {
            <div class="invalid-feedback d-block">{{ specialtyFormGroup.get('name_ar')?.errors?.['backend'] }}</div>
          }
        </div>

        <div class="form-field">
          <label class="form-label">
            الاسم (إنجليزي)
            <span class="required">*</span>
          </label>
          <input
            type="text"
            class="form-control"
            dir="ltr"
            formControlName="name_en"
            placeholder="Ie.g. Electrical"
            [class.is-invalid]="submitted && specialtyFormGroup.get('name_en')?.invalid"
          />
          @if (submitted && specialtyFormGroup.get('name_en')?.errors?.['required']) {
            <div class="invalid-feedback d-block">هذا الحقل مطلوب</div>
          }
          @if (specialtyFormGroup.get('name_en')?.errors?.['backend']) {
            <div class="invalid-feedback d-block">{{ specialtyFormGroup.get('name_en')?.errors?.['backend'] }}</div>
          }
        </div>
      </div>

      <div class="form-field full-width">
        <label class="form-label">
          الوصف (عربي)
          <span class="required">*</span>
        </label>
        <textarea
          class="form-control"
          rows="4"
          formControlName="description_ar"
          placeholder="وصف للتخصص"
          [class.is-invalid]="submitted && specialtyFormGroup.get('description_ar')?.invalid"
        ></textarea>
        @if (submitted && specialtyFormGroup.get('description_ar')?.errors?.['required']) {
          <div class="invalid-feedback d-block">هذا الحقل مطلوب</div>
        }
        @if (specialtyFormGroup.get('description_ar')?.errors?.['backend']) {
          <div class="invalid-feedback d-block">{{ specialtyFormGroup.get('description_ar')?.errors?.['backend'] }}</div>
        }
      </div>

      <div class="form-field full-width">
        <label class="form-label">
          الوصف (إنجليزي)
          <span class="required">*</span>
        </label>
        <textarea
          class="form-control"
          rows="4"
          dir="ltr"
          formControlName="description_en"
          placeholder="Short description"
          [class.is-invalid]="submitted && specialtyFormGroup.get('description_en')?.invalid"
        ></textarea>
        @if (submitted && specialtyFormGroup.get('description_en')?.errors?.['required']) {
          <div class="invalid-feedback d-block">هذا الحقل مطلوب</div>
        }
        @if (specialtyFormGroup.get('description_en')?.errors?.['backend']) {
          <div class="invalid-feedback d-block">{{ specialtyFormGroup.get('description_en')?.errors?.['backend'] }}</div>
        }
      </div>

      @if (apiError) {
        <div class="invalid-feedback d-block">{{ apiError }}</div>
      }
    </div>

    <div mat-dialog-actions class="actions-double">
      <button type="button" class="btn btn-cancel" (click)="cancel()" [disabled]="saving">إلغاء</button>
      <button type="submit" class="btn btn-green" [disabled]="saving">
        {{ isEditMode ? 'تعديل' : 'إضافة' }}
      </button>
    </div>
  </form>
</div>
